// extracted by mini-css-extract-plugin
export default {"headerTabs":"tm3IpPT8ZhEGKF2Qk8ZW","tabsItem":"hGrhfCkrjgGnjr9OrRhO","active":"NEjBvy0X1ECHFhyzsdwC"};